import React, { useCallback, useEffect, useMemo, useState } from "react";
import noPermissionImg from "@/assets/img/joyspce/no-permission.png";
import DelImg from "@/assets/img/supervise-empty.png";
import "./index.less";
import { ErrorCode, ResetErrorCode } from "@/components/Joyspace/types";

interface IProps {
  errCode: string;
}

const ErrorPage = (props: IProps) => {
  const { errCode } = props;
  const [imgSrc, setImgSrc] = useState("");
  const [text, setText] = useState("");

  useEffect(() => {
    if (errCode === ErrorCode.Delete || errCode === ResetErrorCode.Delete) {
      // 文件夹被删除
      setImgSrc(DelImg);
      setText("该文件夹不存在");
    } else if (errCode === ErrorCode.noPermission || errCode === ResetErrorCode.noPermission) {
      // 文件夹无权限
      setImgSrc(noPermissionImg);
      setText("您暂无权限访问群空间文件夹");
    } else if (errCode === "openFolderError") {
      setImgSrc(DelImg);
      // 文件夹打开失败
      setText("文件夹打开失败");
    }
  }, [errCode]);

  return imgSrc ? (
    <div className="groupspace-empty">
      <img src={imgSrc} />
      <p>{text}</p>
    </div>
  ) : null;
};

export default ErrorPage;
